
//--------- スムーススクロール ---------
$(function(){
  var headerHeight = $('header').outerHeight() + 20;
  var urlHash = location.hash;
  if(urlHash) {
    $('body,html').stop().scrollTop(0);
    setTimeout(function(){
      var target = $(urlHash);
      var position = target.offset().top - headerHeight;
      $('body,html').stop().animate({scrollTop:position}, 1000);
    }, 100);
  }
  $('a[href^="#"]').click(function(){
    var href= $(this).attr("href");
    var target = $(href);
    var position = target.offset().top - headerHeight;
    $('body,html').stop().animate({scrollTop:position}, 1000);
    return false;
  });
});

$(document).ready(function () {
  $(window).on("scroll", function () {
    $(".fade-in").each(function () {
      let elementTop = $(this).offset().top;
      let windowBottom = $(window).scrollTop() + $(window).height();
      
      if (windowBottom > elementTop + 140) { // 140px 手前で発火
        $(this).addClass("visible");
      }
    });
  });
});


//--------- フェードイン ---------
$(function () {
  $(window).on('load scroll', function () {
    var winScroll = $(window).scrollTop();
    var winHeight = $(window).height();
    var scrollPos = winScroll + (winHeight * 0.9);

    $(".show").each(function () {
      if ($(this).offset().top < scrollPos) {
        $(this).css({
          opacity: 1,
          transform: 'translate(0, 0)'
        });
      }
    });
  });
});


$(function(){
    function sliderSetting(){
        var width = $(window).width();
        if(width <= 834){
            $('.slider').not('.slick-initialized').slick({
		speed: 5500,
        autoplay: true,
        autoplaySpeed: 0,
        centerMode: true,
        arrows: false,
        cssEase: 'linear',
        centerPadding: '10%',
        dots: false
            });
        } else {
            $('.slide.slick-initialized').slick('unslick');
        }
    }
 
    sliderSetting();
 
    $(window).resize( function() {
        sliderSetting();
    });
});